// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import generalIcons from '~/core/constants/icons/general-svg';

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 1em 0;
`;

export const IconContainer = styled.div`
    background-color: ${({ isModal, theme }) => (isModal ? theme.lightGrey : 'transparent')};
    border-radius: 50%;
    padding: ${props => (props.isModal ? '3em' : 0)};
`;

export const ActionIcon = styled(SVGIcon).attrs({ type: generalIcons.ACTIONS })`
    height: 6em;
    width: 6em;
    & g {
        fill: ${props => props.theme.mainBrandColor}
    }
`;

export const TextBody = styled.p`
    text-align: center;
    line-height: 1.4;
    margin-top: 0;
    white-space: pre;
    & span {
        display: block;
    }
`;

export const SecondaryTextBody = TextBody.extend`
    color: ${props => props.theme.heavyGrey};
    font-size: 0.9em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/discover-splash/styles.js